define('home/models/activities/ReplyActivity',[
    'home/models/Activity',
    'home/activityExpander',
], function (
    Activity,
    activityExpander
) {
    'use strict';

    /**
     * User writes and submits a reply to another comment
     *
     * Relations {
     *     actor: {
     *         type: 'user',
     *         description: 'The user that posted the reply'
     *     },
     *     object: {
     *         type: 'post',
     *         description: 'The comment that was written in reply to another comment'
     *     }
     *     target: {
     *         type: 'post',
     *         description: 'The comment to which the reply was written'
     *     }
     * }
     */
    return Activity.extend({
        defaults: {
            verb: 'reply',
        },

        initialize: function (attributes) {
            this.actor = attributes.actor;
            this.object = attributes.object;
            this.target = attributes.target;
            this.thread = this.object.thread;
        },

        parseRelatedModels: function (attributes, objects) {
            attributes.object = activityExpander.buildPost(objects, attributes.object);

            if (attributes.actor)
                attributes.actor = activityExpander.buildUser(objects, attributes.actor);
            else
                // For anonymous replies, the backend leaves the
                // "actor" field blank (presumably because there is no
                // id for an anonymous user) but our model needs it, so
                // we infer the actor from the object
                attributes.actor = attributes.object.author;

            attributes.target = activityExpander.buildPost(objects, attributes.object.get('parent_post'));

            return attributes;
        },
    });
});

